module.exports = {
  locales: ['en', 'fr', 'es', 'ru', 'pt'],
  defaultLocale: 'en',
  pages: {
    '*': ['common', 'shared'],
    '/': ['common'],
    '/blog/[post]': ['common'],
    '/blog/category/[category]': ['common'],
    '/blog/platform/[platform]': ['common'],
    '/blog/profession/[profession]': ['common'],
  },
};
